import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, color = "var(--yellow)" }) => (
  <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full chunk-sm font-mono-x text-xs uppercase tracking-[0.18em] font-bold"
    style={{ background: color }}>
    {children}
  </span>
);
